import { v1 as color } from '../color'

export default {
  inputSelectDefault: {
    iconColor: color.AQUAMARINE,
    borderColor: color.SILVER,
    focusBorderColor: color.AQUAMARINE,
    labelColor: color.AQUAMARINE,
  },
  inputSelectError: {
    iconColor: color.WATERMELON,
    borderColor: color.WATERMELON,
    focusBorderColor: color.WATERMELON,
    labelColor: color.WATERMELON,
  },
  inputTextDefault: {
    iconColor: color.SILVER,
    borderColor: color.SILVER,
    focusBorderColor: color.AQUAMARINE,
    hoverBorderColor: color.MORTAR,
    labelColor: color.AQUAMARINE,
  },
  inputTextSuccess: {
    iconColor: color.AQUAMARINE,
    borderColor: color.SILVER,
    focusBorderColor: color.AQUAMARINE,
    hoverBorderColor: color.MORTAR,
    labelColor: color.AQUAMARINE,
  },
  inputTextError: {
    iconColor: color.WATERMELON,
    borderColor: color.WATERMELON,
    focusBorderColor: color.WATERMELON,
    hoverBorderColor: color.WATERMELON,
    labelColor: color.WATERMELON,
  },
}
